// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 621) return "scripts/621.js";
	if (chunkId === 993) return "scripts/993.js";
	if (chunkId === 131) return "scripts/131.js";
	if (chunkId === 402) return "scripts/402.js";
	if (chunkId === 939) return "scripts/939.js";
	if (chunkId === 526) return "scripts/526.js";
	if (chunkId === 349) return "scripts/349.js";
	if (chunkId === 795) return "scripts/795.js";
	if (chunkId === 254) return "scripts/254.js";
	if (chunkId === 227) return "scripts/227.js";
	// return url for filenames based on template
	return undefined;
};